





































import Vue from 'vue'
import { Input, Button } from 'element-ui'
import helpers from '@/helpers'
import './KisweInput.scss'

export default Vue.extend({
  name: 'KisweInput',
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String as () => 'text' | 'number',
      required: false,
      default: 'text'
    },
    value: {
      type: [ String, Number ],
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: 'default'
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    tooltip: {
      type: String,
      required: false,
      default: ''
    },
    prepend: {
      type: Object,
      required: false,
      default: () => ({
        type: 'none', // 'none' | 'text' |  'button'
        content: null,
        icon: null,
        disabled: false,
        onClick: null
      })
    },
    append: {
      type: Object,
      required: false,
      default: () => ({
        type: 'none',
        content: null,
        icon: null,
        disabled: false,
        onClick: null
      })
    }
  },
  data: () => ({
    id: `kiswe-input--${ helpers.generateRandomString(12, false) }`
  }),
  computed: {
    val: {
      get (): string {
        return `${this.value}`
      },
      set (newVal: string) {
        if (this.type === 'number') this.$emit('input', parseFloat(newVal))
        else this.$emit('input', newVal)
      }
    }
  },
  methods: {
    onClick (button: 'prepend' | 'append', event: MouseEvent) {
      if (!['append', 'prepend'].includes(button)) return
      const input = document.getElementById(this.id) as HTMLInputElement|undefined
      this[button].onClick?.(this.val, event, input)
    }
  },
  components: {
    'el-input': Input,
    'el-button': Button,
  }
})
